import "./InputAddByEmail.css";

function InputAddByEmail({
  value,
  onChange,
  onSubmit,
  placeholder,
  ariaLabel,
  wrapperClassName = "",
  inputClassName = "",
  iconClassName = "",
  width,
  disabled = false,
  iconSrc = "/imagens/send-email.svg",
  iconAlt = "",
  inputRef,
  "data-testid": dataTestId,
}) {
  const wrapperStyle = width ? { width } : undefined;

  const handleSubmit = () => {
    if (disabled) {
      return;
    }

    if (typeof onSubmit === "function") {
      onSubmit(value);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div
      className={`input-add-by-email-wrapper ${wrapperClassName}`.trim()}
      style={wrapperStyle}
      data-testid={dataTestId}
    >
      <input
        type="text"
        className={`input-add-by-email-field ${inputClassName}`.trim()}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        aria-label={ariaLabel || placeholder}
        disabled={disabled}
        ref={inputRef}
      />

      <img
        src={iconSrc}
        alt={iconAlt || ariaLabel || placeholder}
        className={`input-add-by-email-icon ${iconClassName}`.trim()}
        onClick={handleSubmit}
        style={{ cursor: disabled ? "not-allowed" : "pointer" }}
      />
    </div>
  );
}

export default InputAddByEmail;
